import React, { useContext } from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import SideBarToggle from 'chameleon/ui-stack/ui/basic/side-bar-toggle';
import {
  Context,
  toggleMainNav,
} from 'chameleon/ui-stack/ui/basic/main-nav-two-levels';

const MainNavTwoLevels = () => {
  const [{ isOpen }, dispatch] = useContext(Context);
  const onToggle = (toggle) => {
    toggleMainNav(dispatch, toggle);
  };

  return (
    <div className="desktop:w-98 mobile:w-full flex items-center bg-black h-25 min-h-25 fixed z-50">
      <div className="flex items-center h-full w-25 pl-8.8 pr-4">
        <Icon
          accessibility={{ ariaLabel: 'Logo' }}
          width="26"
          height="32"
          id="logo"
        />
      </div>
      <div className="flex items-center w-full h-full max-w-72.6 mobile:pl-4.6">
        <Icon
          accessibility={{ ariaLabel: 'Ap Classroom', title: 'ap classroom' }}
          width="160"
          height="20"
          id="apc"
        />
      </div>
      <SideBarToggle isSideBarOpen={isOpen} onToggle={onToggle} />
    </div>
  );
};

export default MainNavTwoLevels;
